import { render, staticRenderFns } from "./PurgeVehDetReq.vue?vue&type=template&id=1180bb9f&"
import script from "./PurgeVehDetReq.vue?vue&type=script&lang=js&"
export * from "./PurgeVehDetReq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports